import scanner from "../assets/scanner.jpg"
import Impressora3D from "../assets/impressora3D.jpg"
import raioX from "../assets/raioX.jpg"

const Proficionais = () => {

    return(
        <> 
         <div className="flex flex-col p-4 font-Bask items-center text-center bg-cinza">
            <div>
            <p className='text-5xl text-white  ' >
                Tecnologia, Precisão e Cuidado Humanizado
            </p>
            </div>
           <br/>
            <div>
            <p className='text-3xl ' >
                Na Innovare, a odontologia moderna é proporcionada através
                         da união entre tecnologia de ponta e um cuidado profundamente
                          humano.
            </p>
            </div>
                        
            <div className="flex flex-col sm:flex-row items-start justify-center ">
                <div className="m-10 max-w-80  text-justify max-w-90">
                    <div className="bg-white flex rounded-3xl items-start justify-center" >
                        <img src={scanner} alt="SCANNER" />
                    </div >
                    <p className="text-2xl"><strong>Scanner e planejamento digital </strong></p>
                    <p className="text-sm">Seu Sorriso Desenhado com Precisão. </p>
                    <br/>
                    <p className="text-xl" >
                        Diga adeus às moldagens! Com nosso Scanner 3D, capturamos sua boca 
                        digitalmente, sem desconforto. Essas imagens permitem um Planejamento
                         Digital detalhado, onde seu novo sorriso é desenhado virtualmente.
                          O resultado? Mais conforto, rapidez e a certeza de um tratamento 
                          previsível e estético, feito sob medida para você.
                    </p>
                </div> 

                <div className="m-10 max-w-80 items-start  text-justify max-w-90">
                    <div className="bg-white flex rounded-3xl justify-center" >
                        <img src={Impressora3D} alt="Impressora 3D" />
                    </div>
                    <p className="text-2xl"><strong>Impressora 3D </strong></p>
                    <p className="text-sm">Agilidade e Personalização em Cada Detalhe </p>
                    <br/>
                    <p className="text-xl">
                        Nossa Impressora 3D materializa a odontologia digital. A partir 
                        do planejamento, criamos guias cirúrgicos para implantes, modelos 
                        e peças personalizadas com exatidão milimétrica. Isso significa 
                        tratamentos mais ágeis, com componentes que se encaixam perfeitamente, 
                        reduzindo seu tempo na clínica e garantindo um ajuste impecável.
                    </p>
                </div> 

                <div className="m-10 max-w-80  text-justify max-w-90">
                     <div className="bg-white  flex backdrop:after: rounded-3xl justify-center" >
                        <img src={raioX} alt="Raio X" />
                    </div>
                    <p className="text-2xl"><strong>Raio-X Digital</strong></p>
                    <p className="text-sm">Diagnóstico Seguro e Detalhado</p>
                    <br/>
                    <p className="text-xl">
                        Com o Raio-X Digital, garantimos um diagnóstico seguro e preciso 
                        com menor dose de radiação. As imagens de alta qualidade são instantâneas,
                         permitindo uma análise rápida e eficiente da sua saúde bucal. 
                         É mais segurança para você e um planejamento mais assertivo para seu 
                         tratamento.</p>
                </div>
                
                
            </div>  
         </div>  

        </>
    )
}

export default Proficionais